import { advantages } from '@/mocks/home';

export default function Advantages() {
  return (
    <section className="py-14 md:py-20 bg-background-100">
      <div className="w-full px-4 md:px-6 max-w-7xl mx-auto">
        <div className="text-center mb-10 md:mb-14">
          <div className="inline-flex items-center gap-2 px-3 py-1.5 rounded-full bg-accent-50 mb-4">
            <i className="ri-shield-star-line text-accent-500 text-sm"></i>
            <span className="text-accent-600 text-xs font-medium">平台优势</span>
          </div>
          <h2 className="text-2xl md:text-4xl font-bold text-foreground-900 font-heading mb-3">
            为什么选择<span className="text-primary-600">开云棋牌</span>
          </h2>
          <p className="text-foreground-500 text-sm md:text-base max-w-lg mx-auto">
            六大核心优势，打造行业领先的棋牌娱乐体验
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
          {advantages.map((item, idx) => (
            <div
              key={idx}
              className="group bg-background-50 rounded-xl border border-background-200 p-5 md:p-6 hover:border-accent-200 transition-all duration-300 cursor-default"
            >
              <div className="w-12 h-12 rounded-xl bg-accent-50 flex items-center justify-center mb-4 group-hover:bg-accent-100 transition-colors duration-200">
                <i className={`${item.icon} text-accent-500 text-xl`}></i>
              </div>
              <h3 className="text-base md:text-lg font-bold text-foreground-900 mb-2 font-heading">
                {item.title}
              </h3>
              <p className="text-foreground-500 text-sm leading-relaxed">
                {item.description}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}